import { MaterialIcon } from '@api/types';
import BoltIcon from '@mui/icons-material/Bolt';
import Facebook from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Menu from '@mui/icons-material/Menu';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { SxProps, Theme } from '@mui/material';

export type IconProps = {
  iconName?: MaterialIcon;
  sx?: SxProps<Theme>;
};

export const getMaterialIcon = (iconName?: MaterialIcon) => {
  switch (iconName) {
    case 'AccountCircle':
      return PersonOutlineIcon;
    case 'Facebook':
      return Facebook;
    case 'Instagram':
      return Instagram;
    case 'Menu':
      return Menu;
    case 'ShoppingCart':
      return ShoppingCart;
    case 'BoltIcon':
      return BoltIcon;
    case 'MoneyOffIcon':
      return MoneyOffIcon;
  }
};

export const MdIcon = ({ iconName, sx }: IconProps) => {
  const Icon = getMaterialIcon(iconName);

  // const Icon = (MdIcons as any)?.[iconName];
  // if (!Icon) {
  //   console.warn(`${iconName} not found!`);
  // }
  return Icon ? <Icon sx={sx} className={`md-icon ${iconName}`} /> : null;
};
